import { Flex, Text } from '@vtex/admin-ui'
import { IconContainer } from 'ui'
import { Option, Options } from '../BenefitMenu'
import { BenefitSelectorActionMenu } from './ActionMenu'
import styles from './styles.css'

type BenefitSelectorType = {
  value: string | undefined
  options: Options
  onChange: (name: string) => void
}

function findOption(
  options: Options,
  value: string,
  index: number
): Option | undefined {
  if (index === options.length) {
    return undefined
  }

  if (options[index].name === value) {
    return options[index]
  }

  const child = options[index].children?.find((child) => child.name === value)
  if (child) {
    return child
  }

  return findOption(options, value, index + 1)
}

export function BenefitSelector(props: BenefitSelectorType) {
  const { onChange, value, options } = props

  if (!value) return null

  const option = findOption(options, value, 0)

  if (!option) return null

  const { Icon, label, sectionLabel } = option

  return (
    <Flex className={styles.container} align="center" justify="start">
      <IconContainer rounded>
        <Icon />
      </IconContainer>
      <Text variant="title2">{sectionLabel ?? label}</Text>
      <BenefitSelectorActionMenu
        onChange={onChange}
        selected={value}
        options={options}
      />
    </Flex>
  )
}
